import GroupSettingsAttachments from "./groupSettingsAttachments"

export default GroupSettingsAttachments
